exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3HRSqiGDPJsO0nZeu37ZZw{padding:1.42857rem}@media only screen and (min-width:640px){._3HRSqiGDPJsO0nZeu37ZZw{padding:2.14286rem}}.tsds8sPNIETo9ldwGcSaU{background:#f3f5f7;padding:1em;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){.tsds8sPNIETo9ldwGcSaU{padding-left:2.14286rem;padding-right:2.14286rem}}._1ADdjqBNOkh6WLBOybte-S{width:100%}@media only screen and (min-width:480px){._1ADdjqBNOkh6WLBOybte-S{width:20%;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}}._2kIGEhsL3lmcYSeFOKxDve{margin-top:1em}._2kIGEhsL3lmcYSeFOKxDve a:hover ._3PaIZ7kb_fJV4cfXa5qpx2{-webkit-filter:invert(100%);filter:invert(100%)}.vQW8cAS7knColHYNZ5vrF{font-size:1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressReport_content": "_3HRSqiGDPJsO0nZeu37ZZw",
	"ProgressReport_studentDropdown": "tsds8sPNIETo9ldwGcSaU",
	"ProgressReport_studentDropdown_selectedItem": "_1ADdjqBNOkh6WLBOybte-S",
	"ProgressReport_studentDropdown_options": "_2kIGEhsL3lmcYSeFOKxDve",
	"ProgressReport_studentDropdown_options_aside_checkmark": "_3PaIZ7kb_fJV4cfXa5qpx2",
	"ProgressReport_studentDropdown_options_checkmark": "vQW8cAS7knColHYNZ5vrF"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/UnitReportHFv4/style.postcss
// module id = 1935
// module chunks = 0